import {
  ScheduledLessonsWeekFilters,
  listScheduledLessonsWeek,
} from '@/utils/listScheduledLessonsWeek';

export const scheduledLessonQueries = {
  all: ['scheduledLessons'] as const,

  weekCalendar: (filters: ScheduledLessonsWeekFilters) => ({
    queryKey: [
      ...scheduledLessonQueries.all,
      'weekCalendar',
      { filters },
    ] as const,
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      listScheduledLessonsWeek({ ...filters, pageNumber: pageParam }),
  }),
};
